import { PrismicImage, PrismicLink, PrismicRichText } from "@prismicio/react";

/**
 * @typedef {import("@prismicio/client").Content.KeysSlice} KeysSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<KeysSlice>} KeysProps
 * @param {KeysProps}
 */
const Keys = ({ slice, index }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`bg-${slice.primary.bg_color} ${index !== 0 ? 'border-t-2 border-dark-grey' : ''} bg-grain`}>
   
      <div className="py-12 md:py-20 lg:py-24 px-4 md:px-7 lg:px-10 text-dark-grey">
        <div className="max-w-[1300px] m-auto">
          <h2 className="subtitle mb-6"> {slice.primary.seo_title}</h2>
        </div>
        <div className="xl:flex max-w-[1300px] m-auto">
          <div className="flex grid grid-col-1 md:grid-cols-3 md:gap-5 mb-[40px] lg:gap-10 w-full xl:w-3/4 xl:mr-10">
            {
              slice.primary.points.map((item, i) => {
                return <div key={i} className="w-full max-w-[400px] mb-30px md:max-w-[270px] md:mb-0">
                  <div className="flex w-full md:items-center keys-text">
                    <PrismicImage field={item.picto}
                      className="w-[100px] h-[100px] object-contain mr-5"  loading={index === 0 ? '' : 'lazy'} />
                    <div>
                      <p className="my-5 md:my-0">{item.number}</p>
                      <PrismicRichText field={item.title} components={{ heading3: ({ children }) => <h3 className="md:hidden">{children}</h3> }} />
                    </div>
                  </div>
                  <div className="bg-dark-grey h-[2px] w-full mb-4 -mt-0.5"></div>
                  <div>
                    <PrismicRichText field={item.title} components={{ heading3: ({ children }) => <h3 className="hidden md:block">{children}</h3> }} />
                    <PrismicRichText field={item.text} />
                  </div>
                </div>
              })}
          </div>
          <div className="text-dark-grey text-center xl:text-end m-auto xl:w-1/4">
            <div className="button button-rounded button-text overflow-hidden background-slide-white">
              <PrismicLink field={slice.primary.cta_page} className="cta_form">{slice.primary.cta_label}</PrismicLink>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Keys;
